import { Injectable } from '@angular/core';
import { CustomRequisitionPrecedent } from '@models/requisitions';
import { Dispatch } from '@ngxs-labs/dispatch-decorator';
import * as actions from './business_requisitions.actions';

@Injectable({
	providedIn: 'root',
})
export class BusinessRequisitionsDispatch {
	@Dispatch()
	Create = (customRequisition: CustomRequisitionPrecedent): actions.Create =>
		new actions.Create(customRequisition);

	@Dispatch()
	Update = (customRequisition: CustomRequisitionPrecedent): actions.Update =>
		new actions.Update(customRequisition);

	@Dispatch()
	Remove = (requisitionId: string): actions.Remove =>
		new actions.Remove(requisitionId);
}
